import main from '@merchants/pages/main.vue';
export default [{
    path: 'merchants',
    component: main,
    redirect: 'merchants',
    children: [{
      path: '',
      name: 'merchants',
      meta: {
        title: '子商户进件',
        auth: true
      },
      component: () => import('@merchants/pages/index/index.vue'),
    }, ],
  },
  {
    path: '/merchants/facilitator',
    name: 'facilitator',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/facilitator/index.vue'),
  },
  {
    path: '/merchants/subjectType',
    name: 'subjectType',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/subjectType/index.vue'),
  },
  {
    path: '/merchants/addMerchants',
    name: 'addMerchants',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/addMerchants/index.vue'),
  },
  {
    path: '/merchants/subjectInfo',
    name: 'subjectInfo',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/subjectInfo/index.vue'),
  },
  {
    path: '/merchants/operateInfo',
    name: 'operateInfo',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/operateInfo/index.vue'),
  },
  {
    path: '/merchants/settlementRule',
    name: 'settlementRule',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/settlementRule/index.vue'),
  },
  {
    path: '/merchants/bankInfo',
    name: 'bankInfo',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/bankInfo/index.vue'),
  },
  {
    path: '/merchants/superAdminInfo',
    name: 'superAdminInfo',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/superAdminInfo/index.vue'),
  },
  {
    path: '/merchants/supplementInfo',
    name: 'supplementInfo',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/supplementInfo/index.vue'),
  },
  {
    path: '/merchants/viewProgress',
    name: 'viewProgress',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/viewProgress/index.vue'),
  },
  {
    path: '/merchants/viewDetails',
    name: 'viewDetails',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/viewDetails/index.vue'),
  },
  {
    path: '/merchants/subjectDetails',
    name: 'subjectDetails',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/subjectDetails/index.vue'),
  },
  {
    path: '/merchants/businessDetails',
    name: 'businessDetails',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/businessDetails/index.vue'),
  },
  {
    path: '/merchants/settlementDetails',
    name: 'settlementDetails',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/settlementDetails/index.vue'),
  },
  {
    path: '/merchants/bankDetails',
    name: 'bankDetails',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/bankDetails/index.vue'),
  },
  {
    path: '/merchants/superAdminDetails',
    name: 'superAdminDetails',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/superAdminDetails/index.vue'),
  },
  {
    path: '/merchants/supplementDetails',
    name: 'supplementDetails',
    meta: {
      title: '选择服务商',
      auth: true
    },
    component: () => import('@merchants/pages/supplementDetails/index.vue'),
  }
];